/**
 * Community tab (H-2026-09-12-128 2b) — curated showcase of the resident
 * styles: one card per style_registry row with status='resident', placeholder
 * swatch + style name (representative imagery is a later card). Each card is
 * clickable and behaves like an Inspiration-wall tile (image → A slot →
 * vision/grid chain).
 *
 * Replaces the old product-post community feed (community-gallery.js), which
 * had no live content plan for this tab.
 */

import { CONFIG } from '../../core/config.js'
import { apiRequest, REQUEST_TIMEOUT_MS } from '../../api/index.js'
import { residentItems } from './style-seeds.js'
import { startFromSeedImage } from './inspiration-wall.js'
import { escAttr, escHtml } from '../create/dialog/shell-scaffold.js'
import { createLogger } from '../../utils/logger.js'
const log = createLogger('create-ui.community-styles')

/**
 * Render the resident style cards into the Community right-panel. Called once
 * at boot from initRightPanel(); the panel DOM is static so one render is
 * enough.
 */
export async function renderCommunityStyles() {
  const panel = document.querySelector('[data-rp-panel="community"]')
  if (!panel) return
  panel.innerHTML = '<div class="community-status">Loading…</div>'
  let items
  try {
    const res = await apiRequest(`${CONFIG.FRONTEND_API}/api/customer/styles`, {
      timeoutMs: REQUEST_TIMEOUT_MS.DEFAULT,
    })
    items = residentItems(res?.data?.styles ?? [])
  } catch (err) {
    // Offline/unreachable: known resident seeds keep the tab populated.
    log.warn('community styles fetch failed, using seed fallback:', err?.message || err)
    items = residentItems([])
  }

  panel.innerHTML = `
    <div class="community-grid" role="group" aria-label="Resident styles">
      ${items
        .map(
          (item) => `
        <button type="button" class="community-card" data-url="${escAttr(item.imageUrl)}"
                title="Start from ${escAttr(item.label)}">
          <span class="community-card-swatch" style="background: #${escAttr(item.color)}"></span>
          <span class="community-card-name">${escHtml(item.label)}</span>
        </button>`
        )
        .join('')}
    </div>`

  panel.querySelectorAll('.community-card').forEach((el) => {
    el.addEventListener('click', () => startFromSeedImage(el.dataset.url))
  })
}
